import { QueryClient, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  TEXT_BY_VIDEO_THEME_ID_QUERY_KEY,
  VIDEO_THEME_TEXT_API_URL,
  ALL_VIDEO_THEME_TEXT_QUERY_KEY,
  GET_VIDEO_THEME_TEXTS,
  VIDEO_THEME_TEXT_BY_ID_QUERY_KEY
} from '@/constants';
import { apiUrl } from '@/helpers';
import { ErrorResponse, Options } from '@/types';
import { CreateEditVideoThemeText } from '@/types/VideoThemeTypes';

export const videoThemeTextEndpoints = {
  getTextByVideoThemeId: (videoThemeId: number) =>
    axios.get(`${apiUrl()}${VIDEO_THEME_TEXT_API_URL}/videotheme/${videoThemeId}`),
  deleteVideoThemeText: (id: number) =>
    axios.delete(`${apiUrl()}${VIDEO_THEME_TEXT_API_URL}/${id}`),
  getVideoThemeTextpById: (id: number) => axios.get(`${apiUrl()}${VIDEO_THEME_TEXT_API_URL}/${id}`),
  createVideoThemeText: (payload: CreateEditVideoThemeText) =>
    axios.post(`${apiUrl()}${VIDEO_THEME_TEXT_API_URL}`, payload),
  updateVideoThemeText: (payload: CreateEditVideoThemeText) =>
    axios.put(`${apiUrl()}${VIDEO_THEME_TEXT_API_URL}`, payload)
};

export const useGetTextByVideoThemeIdQuery = (videoThemeId: number, options?: Options) => {
  return useQuery(
    [TEXT_BY_VIDEO_THEME_ID_QUERY_KEY, { videoThemeId }],
    () => videoThemeTextEndpoints.getTextByVideoThemeId(videoThemeId),
    {
      enabled: !!videoThemeId,
      onError: (error) => {
        options?.onError(error as ErrorResponse);
      }
    }
  );
};

export const useDeleteVideoThemeTextMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(videoThemeTextEndpoints.deleteVideoThemeText, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([ALL_VIDEO_THEME_TEXT_QUERY_KEY]);
    }
  });
};

export const useCreateVideoThemeTextMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(videoThemeTextEndpoints.createVideoThemeText, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([GET_VIDEO_THEME_TEXTS]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useUpdateVideoThemeTextMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(videoThemeTextEndpoints.updateVideoThemeText, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([VIDEO_THEME_TEXT_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};
